import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { IconButton, Stack } from "@mui/material";
import React from "react";
import { editUser } from "../api/user";

export const pendingUsersColumns = (setRows) => {
	return [
		{
			headerName: "First Name",
			field: "first_name",
			width: 200,
			editable: false,
		},
		{
			headerName: "Last Name",
			field: "last_name",
			width: 200,
		},
		{
			headerName: "Email",
			field: "email",
			width: 300,
		},
		{
			headerName: "Team Number",
			field: "team_number",
			width: 200,
		},
		{
			headerName: "User Type",
			field: "user_type",
			width: 200,
			renderCell: ({ row }) => (row.user_type === 1 ? "Admin" : row.user_type === 2 ? "Mentor" : "Student"),
		},
		{
			headerName: "Status",
			field: "status",
			width: 200,
			renderCell: ({ row }) => (row.is_pending === 0 ? "Accepted" : "Pending"),
		},
		{
			headerName: "Accept / Deny",
			field: "accept_deny",
			width: 100,
			renderCell: ({ row }) => (
				<Stack direction="row" sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<IconButton
						aria-label="accept"
						color="success"
						size="large"
						onClick={() => {
							editUser({ ...row, is_pending: 0 });
							setRows((prevRows) => prevRows.filter((r) => r.user_id !== row.user_id));
						}}
					>
						<CheckBoxIcon />
					</IconButton>
					<IconButton
						aria-label="deny"
						color="error"
						size="large"
						onClick={() => {
							editUser({ ...row, user_type: 4 });
							setRows((prevRows) => prevRows.filter((r) => r.user_id !== row.user_id));
						}}
					>
						<DisabledByDefaultIcon />
					</IconButton>
				</Stack>
			),
		},
	];
};
